import { setErrorMessageColor, setErrorMessage, setShowError } from "context";
import { appPath } from "./CIAppProp";

export function getBrands(selSilos, filter) {
  const sl = filter.filter((item) => item.title === "Silos");
  // console.log(sl);
  let data = [];
  if (selSilos.length === 0) {
    if (sl[0] !== undefined) {
      sl[0].data.forEach((silo) => {
        data.push(silo);
      });
    }
  } else if (sl.length > 0) data = sl[0].data.filter((silo) => selSilos.indexOf(silo.title) > -1);
  let br = [];
  data.forEach((dt) => {
    const arr = dt.brandlist.split(",");
    br = [...br, ...arr];
  });
  br = [...new Set(br.map((item) => item))];
  br.sort();
  return br;
}

// export function getBrands(selSilos, filter) {
//   const sl = filter.filter((item) => item.title === "Silos");
//   console.log("sl --> ", sl);
//   let data = [];
  
//   sl[0].data.forEach((silo) => {
//     data.push(silo);
//   });

//   let br = [];
//   data.forEach((dt) => {
//     const arr = dt.brandlist.split(",");
//     br = [...br, ...arr];
//   });
//   br = [...new Set(br.map((item) => item))];
//   br.sort();
//   return br;
// }

export function getCatSubCat(catSubCatData, selectedDep, selectedType) {
  const chkDepartment = [];
  if (selectedDep.includes("Boys") || selectedDep.includes("Men")) {
    chkDepartment.push("Male");
  }
  if (selectedDep.includes("Girls") || selectedDep.includes("Women")) {
    chkDepartment.push("Female");
  }
  if (selectedDep.includes("Home")) {
    chkDepartment.push("Home");
  }
  // console.log(chkDepartment);
  let data = [];
  if (chkDepartment.length === 0 && selectedType.length === 0) {
    data = catSubCatData.data;
  } else if (chkDepartment.length > 0 && selectedType.length === 0) {
    data = catSubCatData.data.filter((item) => chkDepartment.includes(item.d));
  } else if (chkDepartment.length === 0 && selectedType.length > 0) {
    data = catSubCatData.data.filter((item) => selectedType.includes(item.p));
  } else if(catSubCatData.data){
    data = catSubCatData.data.filter(
      (item) => chkDepartment.includes(item.d) && selectedType.includes(item.p)
    );
  }
  return data;
}
export function getData(data, key) {
  const dt = [];
  if (data !== undefined) {
    data.forEach((item) => {
      dt.push(item[key]);
    });
  }
  return dt;
}
export function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}
export const fetchData = async (url, jsonReq, dispatch, nevigate) => {
  const url1 = `${appPath}${url}`;
  const requestbody = {
    method: "POST",
    headers: {
      Authorization: `bearer ${sessionStorage.getItem("access_token")}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(jsonReq),
  };
  try {
    const response = await fetch(url1, requestbody);
    const json = await response.json();
    if (json.responseStatus) return json.responseData;
    if (json.error === "invalid_token") {
      setErrorMessage("Login Session expired!");
      setErrorMessageColor("error");
      setShowError();
      setTimeout(() => {
        nevigate("/login");
      }, 5000);
      return [];
    }
    setErrorMessage(dispatch, "Something went Wrong!");
    setErrorMessageColor(dispatch, "warning");
    setShowError(dispatch, true);
    return [];
  } catch (error) {
    return [];
  }
};

export const fetchJsonData = async (url, jsonReq, dispatch, nevigate) => {
  const url1 = `${appPath}${url}`;
  const requestbody = {
    method: "POST",
    headers: {
      Authorization: `bearer ${sessionStorage.getItem("access_token")}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(jsonReq),
  };
  try {
    const response = await fetch(url1, requestbody);
    const json = await response.json();
    if (json.response) return json;
    if (json.message === "invalid_token") {
      setErrorMessage("Login Session expired!");
      setErrorMessageColor("error");
      setShowError();
      setTimeout(() => {
        nevigate("/login");
      }, 5000);
      return [];
    }
    setErrorMessage(dispatch, "Something went Wrong!");
    setErrorMessageColor(dispatch, "warning");
    setShowError(dispatch, true);
    return [];
  } catch (error) {
    return [];
  }
};
export const fetchDataByUrl = async (url, dispatch, nevigate) => {
  const url1 = `${appPath}${url}`;
  const requestbody = {
    method: "POST",
    headers: {
      Authorization: `bearer ${sessionStorage.getItem("access_token")}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await fetch(url1, requestbody);
    const json = await response.json();
    if (json.response) return json;
    if (json.error === "invalid_token") {
      setErrorMessage(dispatch, "Login Session expired!");
      setErrorMessageColor(dispatch, "warning");
      setShowError(dispatch, true);
      setTimeout(() => {
        nevigate("/login");
      }, 5000);
      return [];
    }
  } catch (error) {
    return [];
  }
  return [];
};

const getDefaultSelection = (data) => {
  const res = data.filter((item) => item.defaultvalue === 1);
  return [res[0].title];
};

export const setFilterFromJson = (result, dispatch, brandName) => {
  const { responseData } = result;
  const jsonData = JSON.parse(responseData);
  // console.log(jsonData);
  if (!jsonData) {
    return [];
  }
  dispatch({ type: "SET_FILTER", filter: jsonData });
  //  set defaults
  const filters = {
    isRetailer: "No",
  };
  jsonData.forEach((element) => {
    let { title } = element;
    title = title.toLowerCase();
    if (title === "year" || title.includes("category")) return;
    if (title === "type") title = "miscType";
    filters[title] = getDefaultSelection(element.data);
  });
  filters.brands = getBrands(filters.silos, jsonData);
  //  set default year
  // const selYear = "Feb-2023";
  // filters.year = [selYear];

  const yrlist = jsonData.filter((item) => item.title === "Year");
  const top2year = [];
  
  top2year.push(yrlist[0].data[0]);
  top2year.push(yrlist[0].data[1]);
  filters.year = top2year;

  //set checked department
  if(brandName === "True Classic")
      filters.department = ["Men"];
  else
    filters.department = ["Women"];

  //  set default cat-sub cat
  const catSub = jsonData.filter((item) => item.title === "Category-Sub Category");
  const [catSubCatData] = catSub;
  const data = getCatSubCat(catSubCatData, filters.department, filters.miscType);
  // console.log(data);
  let catData = getData(data, "c");
  let subCatData = getData(data, "s");
  catData = [...new Set(catData.map((item) => item))];
  subCatData = [...new Set(subCatData.map((item) => item))];
  filters.category = catData;
  filters.subCategory = subCatData;
  dispatch({ type: "SET_DEFAULT_FILTER", filter: filters });

  // select top 5 brands only
  const sortData = filters.brands.sort();
  // console.log("filter list", filters.brands);
  // console.log("sortData", sortData);
  let tmp = sortData.slice(0, 5);
  if(!tmp.includes(brandName)){ 
    tmp = sortData.slice(0, 4)
    tmp.push(brandName);
  }
  // console.log("tmp", tmp);
  filters.brands = tmp;
  
  filters.category = filters.category.slice(0, 5);

  return filters;
}